import React from "react";
import Routes from "./Routes/index";

// Import Scss
import "./assets/scss/theme.scss";

// Firebase
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Firebase Configuration from google-services.json
const firebaseConfig = {
  apiKey: "AIzaSyAMj3uig6x0O996bfdVeCEmT3uGtgS0YeA",
  authDomain: "poppygrid-prod.firebaseapp.com",
  projectId: "poppygrid-prod",
  storageBucket: "poppygrid-prod.firebasestorage.app",
  messagingSenderId: "866865525923",
  appId: "1:866865525923:web:97899bf502b38aa3453b16",
  measurementId: "G-WKJDQ45KNT", // Replace with actual Web app ID from Firebase Console
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

function App() {
  return (
    <React.Fragment>
      <Routes />
    </React.Fragment>
  );
}

export default App;
